import { render, staticRenderFns } from "./fundsFromDetails.vue?vue&type=template&id=721c24c2&"
import script from "./fundsFromDetails.vue?vue&type=script&lang=js&"
export * from "./fundsFromDetails.vue?vue&type=script&lang=js&"
import style0 from "./fundsFromDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports